<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
    <CModal
      :closeOnBackdrop="false"
      :show.sync="modal"
      :no-close-on-backdrop="false"
      :centered="true"
      title=""
      size="lg"
      color="dark"
    >
      <CCard>
        <CCardBody>
          <CAlert
            v-if="alertMsg"
            :color="alertClr"
            closeButton
            fade
          >
            {{ alertMsg }}
          </CAlert>
          <CForm>
            <ValidationProvider
              :rules="`max:${constdata.USER_NEAREST_MAX_LEN}`"
              v-slot="{ errors }"
              name="最寄り駅"
            >
              <CInput
                label="最寄り駅"
                v-model="inputItems.nearest_station"
                horizontal
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            
            <ValidationProvider
              :rules="`required|between:${constdata.USER_YEARS_EXPERIENCE_MIN_VAL},${constdata.USER_YEARS_EXPERIENCE_MAX_VAL}`"
              v-slot="{ errors }"
              name="入社前業界経験年数"
            >
              <CInput
                label="入社前業界経験年数 *"
                v-model.number="inputItems.years_experience"
                type="number"
                horizontal
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            
          </CForm>
        </CCardBody>
      </CCard>
      <template #header>
        <h6 class="modal-title" ref="modal-title">アカウント情報更新</h6>
        <CButtonClose @click="closeModal" class="text-white" />
      </template>
      <template #footer>
        <CButton
          @click="alertValidation(handleSubmit(update))"
          color="success"
          >更新</CButton
        >
      </template>
    </CModal>
  </ValidationObserver>
</template>

<script>
//TODO 定数定義のコンポーネント群は共通に移す
import constMsg from "../../../definition/const/const_message.js";
import constdata from "../../../definition/const/const_user.js";

export default {
  name: "AccountEditModal",
  data() {
    return {    
      modal: false,
      alertMsg: "",
      alertClr: "",
      constdata: constdata,
    };
  },
  watch: {
    visible: {
      handler: function () {
        this.modal = this.visible;
      },
    },
  },
  computed: {
    inputItems() {
      return { ...this.data };
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
    data: {
      type: Object,
    },
  },
  methods: {
    closeModal() {
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // 画面クローズ
      this.modal = false;
      this.$emit("close");
    },
    alertValidation() {
      // バリデーションエラーがあればエラーメッセージを表示
      this.$refs.observer.validate().then((success) => {
        if (!success) {
          // モーダルを閉じずにバリデーションエラーメッセージを表示
          this.alertClr = "danger";
          this.alertMsg =
            "入力内容に不備があります。詳細は各項目を確認してください。";
          // モーダルトップへスクロール
          this.$refs["modal-title"].scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      });
    },
    async update() {
      var id = this.inputItems.user_id;
      // ログインユーザーIDをパラメーターに含める
      this.inputItems.login_user_id = this.$store.state.loginUser.user_id;
      // 更新処理
      const ret = await this.updateUser(id, this.inputItems);
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // 画面クローズ
      this.modal = false;
      this.$emit("close", ret);
    },
    async updateUser(id, param) {
      let ret = {};
      await this.$axios
        .put("/api/v1/users/" + id + "?=profile", param)
        .then((res) => {
          ret.alertClr = "success";
          ret.alertMsg = constMsg.I0003_JP;
        })
        .catch((e) => {
          ret.alertClr = "danger";
          ret.alertMsg = e.response.data.message;
        });
      return ret;
    },
  },
};
</script>